import { render, staticRenderFns } from "./ContactGC.vue?vue&type=template&id=5c367683&scoped=true"
import script from "./ContactGC.vue?vue&type=script&lang=js"
export * from "./ContactGC.vue?vue&type=script&lang=js"
import style0 from "./ContactGC.vue?vue&type=style&index=0&id=5c367683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c367683",
  null
  
)

export default component.exports